import { recordPageView } from '@/campfire/usage';

// Vendors loaded by the admin layout's head partials. Each is absent outside production or
// under Cypress, and HubSpot swaps its `_hsq` array for an object once its script loads.
interface AnalyticsWindow {
  ga?: (...args: unknown[]) => void;
  userpilot?: { reload?: () => void };
  _hsq?: { push: (command: unknown[]) => void };
}

/**
 * Pageview calls for a client-side navigation. Document loads already run the head partials,
 * so the shell calls this only after the first location. GA4 and Pendo detect history
 * changes themselves.
 */
export const trackClientNavigation = (path: string): void => {
  recordPageView(path);
  const vendors = window as unknown as AnalyticsWindow;
  if (typeof vendors.ga === 'function') {
    vendors.ga('set', 'page', path);
    vendors.ga('send', 'pageview');
  }
  if (typeof vendors.userpilot?.reload === 'function') vendors.userpilot.reload();
  const { _hsq: hubspot } = vendors;
  if (typeof hubspot?.push === 'function') {
    hubspot.push(['setPath', path]);
    hubspot.push(['trackPageView']);
  }
};
